import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FaUserShield, FaUsersCog, FaLaptop, FaBolt, FaHistory, FaCreditCard, FaExchangeAlt, FaSearch, FaChartLine, FaCog } from "react-icons/fa";
import './Dashboard.css';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    userInfo: {},
    userBalance: 0,
    allUserTransactions: {},
    todaysRecharges: 0,
    totalCardsRecharged: 0,
    totalCardsRechargeAmount: 0,
    totalCallLogs: 0,
    totalCallCharges: 0,
    todaysCallLogs:0,
    todaysCallCharges:0,
    todaysCardsRechargeAmount:0,
    todaysCardsRecharged:0
  });

  const navigate = useNavigate();
  
  const fnAdminClick = (e) => {
    navigate("/SuperAdmin/ManageAdmin");
  }
  
  const fnManageOrganizationClick = (e) => {
    navigate("/SuperAdmin/ManageOrganization");
  }

  const fnCreateDeviceClick = (e) => {
    navigate("/SuperAdmin/CreateDevice");
  }

  const fnCreateCardClick = (e) => {
    navigate("/SuperAdmin/CreateCard");
  }
  
  const fnRechargeClick = (e) => {
    navigate("/SuperAdmin/Recharge");
  }
  
  const fnAdminTransactions = (e) => {
    navigate("/SuperAdmin/TransactionHistory")
  }
  
  const fnCallingReport = () => {
    navigate("/SuperAdmin/CallingReport")
  }
  
  const fnSearchCardsandDevices = () => {
    navigate("/SuperAdmin/SearchCardsandDevices")
  }

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");

    if (!token) {
      navigate("/");
    } else {
      fnDashboardLoad();
    }
  }, [navigate]);

  
  function fnDashboardLoad() {
    const BASE_URL = window.BASE_URL + '/get_dashboardInfo';
    var config = {
      method: 'get',
      url: BASE_URL,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    };

    axios.request(config)
      .then(function (response) {
        if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results != undefined) {
          setDashboardData(response.data.results);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Calculate percentages for progress circles
  const calculatePercentage = (current, total) => {
    if (total === 0) return 0;
    return Math.min(100, Math.round((current / total) * 100));
  };

  const agentPercentage = calculatePercentage(
    dashboardData.allUserTransactions?.AGENT || 0,
    dashboardData.allUserTransactions?.SELF || 1
  );

  const cardPercentage = calculatePercentage(
    dashboardData.totalCardsRechargeAmount || 0,
    dashboardData.allUserTransactions?.AGENT || 1
  );

  const callPercentage = calculatePercentage(
    dashboardData.totalCallCharges || 0,
    dashboardData.totalCardsRechargeAmount || 1
  );

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Dashboard</h1>
      </div>
      
      <div className="dashboard-content">
        {/* Balance Card */}
        <div className="balance-card">
          <div className="balance-left">
            <div className="admin-label">Super Admin Name</div>
            <div className="admin-name">{dashboardData.userInfo?.name || 'Default Super Admin'}</div>
            <div className="mobile-label">Mobile</div>
            <div className="mobile-number">{dashboardData.userInfo?.mobile || '0000000000'}</div>
          </div>
          <div className="balance-divider"></div>
          <div className="balance-right">
            <div className="balance-label">Balance Units</div>
            <div className="balance-amount">{(dashboardData.userBalance || 0)}</div>
          </div>
        </div>

        {/* Overall Progress and Today's Side by Side */}
        <div className="stats-container">
          {/* Overall Progress Section */}
          <div className="progress-section">
            <h2 className="section-title">Overall Progress</h2>
            <div className="progress-cards">
              <div className="progress-card">
                <svg className="progress-circle" viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#e0e0e0" strokeWidth="10"/>
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#ff8c00" strokeWidth="10"
                    strokeDasharray={`${agentPercentage * 3.14} ${100 * 3.14}`}
                    strokeDashoffset="78.5"
                    strokeLinecap="round"
                    transform="rotate(-90 60 60)"/>
                  <text x="60" y="55" textAnchor="middle" fontSize="28" fontWeight="bold" fill="#ff8c00">{agentPercentage}</text>
                  <text x="60" y="75" textAnchor="middle" fontSize="18" fill="#ff8c00">%</text>
                </svg>
                <div className="progress-label">AGENT</div>
                <div className="progress-stats">
                  {(dashboardData.allUserTransactions?.AGENT || 0)}/
                  {(dashboardData.allUserTransactions?.SELF || 0)}
                </div>
              </div>
              
              <div className="progress-card">
                <svg className="progress-circle" viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#e0e0e0" strokeWidth="10"/>
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#ff8c00" strokeWidth="10"
                    strokeDasharray={`${cardPercentage * 3.14} ${100 * 3.14}`}
                    strokeDashoffset="78.5"
                    strokeLinecap="round"
                    transform="rotate(-90 60 60)"/>
                  <text x="60" y="55" textAnchor="middle" fontSize="28" fontWeight="bold" fill="#ff8c00">{cardPercentage}</text>
                  <text x="60" y="75" textAnchor="middle" fontSize="18" fill="#ff8c00">%</text>
                </svg>
                <div className="progress-label">CARD</div>
                <div className="progress-stats">
                  {(dashboardData.totalCardsRechargeAmount || 0)}/
                  {(dashboardData.allUserTransactions?.AGENT || 0)}
                </div>
              </div>
              
              <div className="progress-card">
                <svg className="progress-circle" viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#e0e0e0" strokeWidth="10"/>
                  <circle cx="60" cy="60" r="50" fill="none" stroke="#ff8c00" strokeWidth="10"
                    strokeDasharray={`${callPercentage * 3.14} ${100 * 3.14}`}
                    strokeDashoffset="78.5"
                    strokeLinecap="round"
                    transform="rotate(-90 60 60)"/>
                  <text x="60" y="55" textAnchor="middle" fontSize="28" fontWeight="bold" fill="#ff8c00">{callPercentage}</text>
                  <text x="60" y="75" textAnchor="middle" fontSize="18" fill="#ff8c00">%</text>
                </svg>
                <div className="progress-label">CALL</div>
                <div className="progress-stats">
                  {(dashboardData.totalCallCharges || 0)}/
                  {(dashboardData.totalCardsRechargeAmount || 0)}
                </div>
              </div>
            </div> 
          </div>

          {/* Today's Section */}
          <div className="today-section">
            <h2 className="section-title">Today's</h2>
            <div className="today-grid">
              <div>
                <div className="today-category">Recharges</div>
                <div className="today-row">
                  <span className="today-label">Users</span>
                  <span className="today-value">
                    <span className="today-primary">{dashboardData.rechargeAmount  || 0}</span>
                    <span className="today-secondary"> ({dashboardData.todaysRecharges || 0})</span>
                  </span>
                </div>
                <div className="today-row">
                  <span className="today-label">Cards</span>
                  <span className="today-value">
                    <span className="today-primary">{dashboardData.todaysCardsRechargeAmount || 0}</span>
                    <span className="today-secondary"> ({ dashboardData.todaysCardsRecharged || 0})</span>
                  </span>
                </div>
              </div>
              {/* <div className="today-divider"></div> */}
              <div>
                <div className="today-category">Calling</div>
                <div className="today-row">
                  <span className="today-label">Calls</span>
                  <span className="today-value">
                    <span className="today-primary">{ dashboardData.todaysCallCharges|| 0}</span>
                    <span className="today-secondary"> ({ dashboardData.todaysCallLogs || 0})</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Menu Grid */}
        <div className="menu-grid">
          <div className="menu-item" onClick={fnAdminClick}>
            <FaUserShield className="menu-icon" />
            <div className="menu-label">Admins</div>
          </div>
          
          <div className="menu-item" onClick={fnRechargeClick}>
            <FaBolt className="menu-icon" />
            <div className="menu-label">Recharge</div>
          </div>
          
          <div className="menu-item" onClick={fnCreateDeviceClick}>
            <FaLaptop className="menu-icon" />
            <div className="menu-label">Devices</div>
          </div>
          
         <div className="menu-item" onClick={fnManageOrganizationClick}>
            <FaUsersCog className="menu-icon" />
            <div className="menu-label">Organizations</div>
          </div>
          
          <div className="menu-item" onClick={fnSearchCardsandDevices}>
            <FaSearch className="menu-icon" />
            <div className="menu-label">Search</div>
          </div>
          
          <div className="menu-item" onClick={fnAdminTransactions}>
            <FaExchangeAlt className="menu-icon" />
            <div className="menu-label">Transactions</div>
          </div>
          
          <div className="menu-item" onClick={fnCallingReport}>
            <FaChartLine className="menu-icon" />
            <div className="menu-label">Calling Report</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;